// @flow
import * as React from 'react';

import Checkbox from 'components/CheckboxNew';

import styles from './styles.module.scss';

type Props = {
  items: Array<{
    name: string,
    paymentName: string,
    Icon: React.Node,
  }>,
  checked: any,
  handleCheckbox: (
    index: number,
    setCheckedItems: (any) => void,
    checked: any,
  ) => void,
  setCheckedItems: () => void,
}

export default (
  {
    items,
    checked,
    handleCheckbox,
    setCheckedItems,
  }: Props,
) => (
  <div className={styles.block}>
    <div className={styles.container}>
      {
        React.useMemo(() => items.map(({ name, Icon, paymentName }) => (
          // eslint-disable-next-line max-len
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div
            className={styles.wrapper}
            key={name}
            onClick={() => handleCheckbox(paymentName, setCheckedItems, checked)}
          >
            <Checkbox
              checked={checked[`${paymentName}`]}
              onCheck={() => {}}
              type="circular"
              label={name}
            />
            {Icon}
          </div>
        )), [checked])
      }
    </div>
  </div>
);
